import { computed, inject, onMounted, ref, useTemplateRef } from 'vue';

import { scrollToElement } from '@/utils/smoothScroll';

export const useAccordionItem = (props: any, emits: any) => {
  const generateAccordionId: any = inject('generateAccordionId');
  const isAccordionOpen: any = inject('isAccordionOpen');
  const toggleAccordionPanelById: any = inject('toggleAccordionPanelById');

  const accordionId = ref(null);
  const fallbackOpen = ref(false);

  const accordionItemHeader = useTemplateRef<HTMLDivElement | undefined>('accordionItemHeader');

  onMounted(() => {
    if (!generateAccordionId) {
      return;
    }
    accordionId.value = generateAccordionId();
  });

  const isOpen = computed(() => {
    if (!props.ignoreOthers && isAccordionOpen) {
      return isAccordionOpen(accordionId.value);
    }
    return fallbackOpen.value;
  });

  const toggleAccordion = (behavior: ScrollBehavior = 'smooth') => {
    if (!props.ignoreOthers && toggleAccordionPanelById) {
      toggleAccordionPanelById(accordionId.value);
    } else {
      fallbackOpen.value = !fallbackOpen.value;
    }

    if (props.scrollTo && isOpen.value && accordionItemHeader.value) {
      if (!props.ignoreOthers) {
        setTimeout(() => {
          // @ts-ignore
          scrollToElement(accordionItemHeader.value, behavior);
        }, 700);
      } else {
        // @ts-ignore
        scrollToElement(accordionItemHeader.value, behavior);
      }
    }

    emits('accordion-item-toggle', isOpen.value);
  };

  return {
    isOpen,
    toggleAccordion,
  };
};
